<template>
    <div container-table>
        <header>
            <h1 class="d-flex justify-content-center">Projects</h1>
        </header>
        <div class="py-1">
            <div class="container-form">
                <div class="add-btn">
                    <button style="margin-bottom:5px;" @click="$router.push({ path: 'projects/edit' })" class="btn btn-primary">Add</button>
                </div>
                <div class="table-content">
                    <div class="d-flex justify-content-center">
                        <ag-grid-vue style="width:1100px;"
                                        class="ag-theme-balham"
                                        :gridOptions="gridOptions"
                                        :columnDefs="columnDefs"
                                        :rowData="rowData"
                                        rowSelection='single'
                                        domLayout='autoHeight'>
                        </ag-grid-vue>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">

    .add-btn {
        padding-left: 3em;
        align-self: flex-end;
    }
    /* Works on Chrome, Edge, and Safari */

    ::-webkit-scrollbar {
        width: 10px;
    }

    ::-webkit-scrollbar-track {
        background: transparent;
    }

    ::-webkit-scrollbar-thumb {
        background-color: rgba(155, 155, 155, 0.5);
        border-radius: 20px;
        border: transparent;
    }

    body {
        overflow: hidden;
    }


</style>

<script>
    // @ is an alias to /src
    import { AgGridVue } from "ag-grid-vue";
    import axios from 'axios'

    export default {
        name: 'projects',
        components: {
            AgGridVue
        },
        data: function () {
            return {
                info: null,
                loading: true,
                errored: false,
                columnDefs: null,
                gridOptions: null,
                rowData: null
            }
        },
        beforeMount() {
            this.gridOptions = {
                defaultColDef: {
                    filter: true // set filtering on for all cols
                },
                //select row instead
                suppressCellSelection: true,
                maxWidth: 300,
            }


            this.columnDefs = [
                {
                    headerName: 'Number', field: 'projectNumber', width: 120,
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        text.addEventListener('click', (e) => {
                            e.preventDefault
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        return text;
                    }
                },
                {
                    headerName: 'Name', field: 'projectName',
                    //manually binding event to each cell as rowclick is getting auto triggered
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        text.addEventListener('click', (e) => {
                            e.preventDefault();
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        return text;
                    }
                },
                {
                    headerName: 'PI Name', field: 'projectManagers', width: 300,
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value.map(x => x.displayName).join(', ');

                        text.addEventListener('click', (e) => {
                            e.preventDefault
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        return text;
                    }
                },
                {
                    headerName: 'Start Date', field: 'startDate', width: 160,
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value ? (new Date(params.value)).toLocaleDateString() : '';
                        text.addEventListener('click', (e) => {
                            e.preventDefault();
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        return text;
                    },
                    valueFormatter: function (data) {
                        return data.value ? (new Date(data.value)).toLocaleDateString() : '';
                    }
                },
                {
                    headerName: 'End Date', field: 'endDate', width: 160,
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value ? (new Date(params.value)).toLocaleDateString() : '';
                        text.addEventListener('click', (e) => {
                            e.preventDefault();
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        return text;
                    }
                },
                {
                    headerName: 'Archived', field: 'archived', width: 140,
                    cellRenderer: (params) => {
                        var text = document.createElement('div');
                        text.innerText = params.value;
                        text.addEventListener('click', (e) => {
                            e.preventDefault();
                            this.$router.push({ name: "projects-edit", params: { id: params.data.id } });
                        });
                        return text;
                    }
                }
            ];

            //TODO: refactor into enterprise http client
            axios
                .get(this.$hostname + 'projects', {
                    headers: {
                        "Authorization": "Bearer " + this.msal.accessToken
                    }
                })
                .then(response => {
                    this.rowData = response.data
                })
                .catch(error => {
                    this.$notify({
                        group: 'errors',
                        type: 'error',
                        title: 'Error',
                        text: error
                    });
                    this.errored = true
                })
                .finally(() => this.loading = false)

        },
        mounted() {

        },
        methods: {
        }
    }
</script>